import * as React from "react";

const { Component } = React;

import { FormGroup, Input, Label } from "reactstrap";

import { createOrSaveIntegration } from "./IntegrationStore";
import { alert } from "../general/alertStore.js";
import IntegrationTrigger from "./IntegrationTrigger";
import axios from "../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";

class AzurePhotoIntegrationConfig {
    managedServiceID?: string;
    exportStaff: boolean;
    exportStudents: boolean;
    exportParents: boolean;
    exportGuests: boolean;

    constructor(config) {
        let _config = config || {};
        this.managedServiceID = _config.managedServiceID || "";
        this.exportStaff = _config.exportStaff === undefined || _config.exportStaff === null ? true : _config.exportStaff;
        this.exportStudents = _config.exportStudents === undefined || _config.exportStudents === null ? true : _config.exportStudents;
        this.exportParents = _config.exportParents === undefined || _config.exportParents === null ? false : _config.exportParents;
        this.exportGuests = _config.exportGuests === undefined || _config.exportGuests === null ? false : _config.exportGuests;
    }
}

class AzurePhotoIntegration {
    config: AzurePhotoIntegrationConfig;
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;
    organizationId: string;

    constructor(integration: any = {}) {
        this.name = integration.name || "";
        this.integrationDirection = integration.integrationDirection;
        this.integrationType = integration.integrationType;
        this.integrationId = integration.integrationId;
        this.triggerId = integration.triggerId;
        this.triggerLastRun = integration.triggerLastRun;
        this.triggerEnabled = integration.triggerEnabled;
        this.organizationId = integration.organizationId;

        this.config = new AzurePhotoIntegrationConfig(integration.config);
    }
}

interface AzurePhotoState {
    profiles: Array<AzurePhotoIntegration>;
    users: any;
    selectedProfile: AzurePhotoIntegration;
    selectedProfileId: string;
    syncResult: any;

    managedServices: Array<any>;
}

interface AzurePhotoProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class ExportAzurePhotos extends Component<AzurePhotoProps, AzurePhotoState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new AzurePhotoIntegration(),
            selectedProfileId: "",
            syncResult: undefined,
            managedServices: [],
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 1; //Out
                    prevState.selectedProfile.integrationType = 9; //AzurePhoto
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    syncUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/ExportPhotosToAzure`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: response.data.success ? "alert-success" : "alert-danger",
                    text: response.data.success ? `Photos synced successfully` : response.data.errors.join("\n"),
                });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/9`) //AzurePhoto
            .then((response) => {
                this.setState({ profiles: response.data, selectedProfile: new AzurePhotoIntegration(), selectedProfileId: "" });
            });

        axios
            .get(`/api/ManagedServices/ListManagedServices/${this.props.organization}/5`) //AzurePhoto
            .then((response) => {
                this.setState({ managedServices: response.data });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({
            selectedProfileId: id,
            selectedProfile: new AzurePhotoIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]),
        }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handleManagedServiceChange = (e) => {
        let managedService = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.managedServiceID = managedService;
            return prevState;
        });
    };

    handleExportStaffChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportStaff = checked;
            return prevState;
        });
    };

    handleExportStudentsChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportStudents = checked;
            return prevState;
        });
    };

    handleExportParentsChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportParents = checked;
            return prevState;
        });
    };

    handleExportGuestsChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportGuests = checked;
            return prevState;
        });
    };

    render() {
        return (
            <div>
                <h3>Azure Photos</h3>

                <div className="row">
                    <div className="col-12">
                        <div className="form-group row">
                            <label className="col-xs-12 col-md-3 col-form-label">Profile</label>
                            <div className="col-xs-12 col-md-9 pl-0">
                                <Input type="select" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                                    <option>Please Select</option>
                                    {this.state.profiles.map((profile) => (
                                        <option key={profile.integrationId} value={profile.integrationId}>
                                            {profile.name}
                                        </option>
                                    ))}
                                </Input>
                            </div>
                        </div>
                    </div>
                    {this.state.selectedProfileId && (
                        <div className="col-12">
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group row">
                            <label className="col-xs-12 col-md-3 col-form-label">Profile Name</label>
                            <div className="col-xs-12 col-md-9 pl-0">
                                <input type="text" className="form-control" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                            </div>
                        </div>
                    </div>
                    {!this.state.selectedProfileId && (
                        <div className="col-xs-12 col-md-6">
                            <div className="d-flex align-items-end flex-column pt-4">
                                <div className="mt-auto">
                                    <button className="btn btn-success me-1" type="button" onClick={this.saveProfile}>
                                        Create Profile
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {this.state.selectedProfileId && (
                    <div>
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">Managed Service</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <Input type="select" value={this.state.selectedProfile.config.managedServiceID} onChange={this.handleManagedServiceChange}>
                                            <option value="">Please Select</option>
                                            {this.state.managedServices.map((m) => (
                                                <option key={m.id} value={m.id}>
                                                    Tenant: {m.configuration.tenantID}
                                                </option>
                                            ))}
                                        </Input>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <div className="col-xs-12 col-md-9">
                                        <FormGroup check>
                                            <Input
                                                type="switch"
                                                label=""
                                                id="exportStaff"
                                                checked={this.state.selectedProfile.config.exportStaff}
                                                onChange={this.handleExportStaffChange}
                                            />
                                            <Label for="exportStaff" check>
                                                Export Staff
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <div className="col-xs-12 col-md-9">
                                        <FormGroup check>
                                            <Input
                                                type="switch"
                                                label=""
                                                id="exportStudents"
                                                checked={this.state.selectedProfile.config.exportStudents}
                                                onChange={this.handleExportStudentsChange}
                                            />
                                            <Label for="exportStudents" check>
                                                Export Students
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <div className="col-xs-12 col-md-9">
                                        <FormGroup check>
                                            <Input
                                                type="switch"
                                                label=""
                                                id="exportParents"
                                                checked={this.state.selectedProfile.config.exportParents}
                                                onChange={this.handleExportParentsChange}
                                            />
                                            <Label for="exportParents" check>
                                                Export Parents
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <div className="col-xs-12 col-md-9">
                                        <FormGroup check>
                                            <Input
                                                type="switch"
                                                label=""
                                                id="exportGuests"
                                                checked={this.state.selectedProfile.config.exportGuests}
                                                onChange={this.handleExportGuestsChange}
                                            />
                                            <Label for="exportGuests" check>
                                                Export Guests
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xs-12 col-md-6">
                                <div className="d-flex align-items-end flex-column pt-4">
                                    <div className="mt-auto">
                                        <button className="btn btn-success me-1" type="button" onClick={this.saveProfile}>
                                            Save Profile
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex align-items-end flex-column pt-4">
                                    <div className="mt-auto">
                                        <button className="btn btn-primary" type="button" onClick={this.syncUsers}>
                                            Sync
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">{this.state.syncResult && !this.state.syncResult.success && <div>Errors</div>}</div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
